export const CALL_BAR_HEIGHT = 48;
